import {
  Menu,
  MenuItem,
  Dialog,
  Button,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@mui/material';
import { useContext, useState, useRef } from 'react';
import ToastContext from 'src/contexts/toast-context';
import AddIcon from '@mui/icons-material/Add';

const SelectAttachment = ({
  handleFileInput,
  onLinkSave,
  disableDocumentUpload,
  disableLinkUpload,
}) => {
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkInput, setLinkInput] = useState('');
  const fileInputRef = useRef();
  const { error } = useContext(ToastContext);
  const validLinkRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+|^$/;

  // Used for add attachment dropdown
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  const handleLinkChange = (e) => {
    setLinkInput(e.target.value);
  };

  const handleLinkSave = () => {
    if (validLinkRegex.test(linkInput)) {
      onLinkSave(linkInput);
      setShowLinkModal(false);
    } else {
      error('Invalid link. Please enter a valid YouTube link.');
    }
  };

  return (
    <>
      <input
        type="file"
        id="fileInput"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept=".pdf,.jpg,.jpeg,.png,.mp4,.avi"
        onChange={handleFileInput}
      />
      <div>
        <Button
          variant="contained"
          id="attachmentDropdown"
          aria-controls={open ? 'attachment-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          startIcon={<AddIcon />}
        >
          Add Attachment
        </Button>
        <Menu
          id="attachment-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'attachmentDropdown' }}
        >
          <MenuItem
            onClick={() => {
              openFileDialog();
              handleClose();
            }}
            data-cy="file-upload"
            disabled={disableDocumentUpload}
          >
            File
          </MenuItem>
          <MenuItem
            onClick={() => {
              setShowLinkModal(true);
              handleClose();
            }}
            data-testid="video-link-upload"
            disabled={disableLinkUpload}
          >
            Video
          </MenuItem>
        </Menu>
      </div>
      <small className="text-muted">Max 5 files allowed, 40MB max file size each</small>

      <Dialog open={showLinkModal} onClose={() => setShowLinkModal(false)}>
        <DialogTitle>Please insert your link here:</DialogTitle>
        <DialogContent>
          <input
            type="text"
            placeholder="https://.."
            style={{ fontStyle: 'italic' }}
            className="form-control"
            onChange={handleLinkChange}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={() => setShowLinkModal(false)}>
            Cancel
          </Button>
          <Button variant="contained" color="success" onClick={handleLinkSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectAttachment;
